import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.99935 1.33398C6.1584 1.33398 4.66602 2.82637 4.66602 4.66732C4.66602 6.50827 6.1584 8.00065 7.99935 8.00065C9.8403 8.00065 11.3327 6.50827 11.3327 4.66732C11.3327 2.82637 9.8403 1.33398 7.99935 1.33398ZM5.99935 4.66732C5.99935 3.56275 6.89478 2.66732 7.99935 2.66732C9.10392 2.66732 9.99935 3.56275 9.99935 4.66732C9.99935 5.77189 9.10392 6.66732 7.99935 6.66732C6.89478 6.66732 5.99935 5.77189 5.99935 4.66732Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.99935 8.66732C5.05383 8.66732 2.66602 11.0551 2.66602 14.0007C2.66602 14.3688 2.96449 14.6673 3.33268 14.6673H12.666C13.0342 14.6673 13.3327 14.3688 13.3327 14.0007C13.3327 11.0551 10.9449 8.66732 7.99935 8.66732ZM7.99935 10.0007C9.98135 10.0007 11.6267 11.4422 11.944 13.334H4.05465C4.37204 11.4422 6.01735 10.0007 7.99935 10.0007Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}